// Imports => React
import React, {memo, forwardRef, useMemo} from 'react';
import {Props} from './ac-card.proptypes';
import clsx from 'clsx';

// Imports => Utilities
import {AcIsSet, AcUUID, AcGenerateThemeClassNames} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-card',
  THEME: AcGenerateThemeClassNames('ac-card'),
  PLACEHOLDER: 'ac-card--placeholder',
  SQUARE: 'ac-card--square',
  FLAT: 'ac-card--flat',
  RAISED: 'ac-card--raised',
  DENSE: 'ac-card--dense',
  NARROW: 'ac-card--narrow',
  FULLHEIGHT: 'ac-card--fullheight',
  NO_BORDER: 'ac-card--no-border',
  OVERFLOW: 'ac-card--overflow',
};

// Component
const AcCard = memo(
  forwardRef(
    (
      {
        id = AcUUID(),
        theme = 'default',
        square = false,
        flat = true,
        raised = false,
        dense = false,
        narrow = false,
        fullheight = false,
        noBorder = false,
        isPlaceholder = false,
        overflow = true,
        width,
        height,
        className,
        children,
        ...rest
      },
      ref
    ) => {
      const getStyleClassNames = useMemo(() => {
        return clsx(
          _CLASSES.MAIN,
          theme && _CLASSES.THEME[theme.toUpperCase()],
          square && _CLASSES.SQUARE,
          dense && _CLASSES.DENSE,
          narrow && _CLASSES.NARROW,
          flat && _CLASSES.FLAT,
          raised && _CLASSES.RAISED,
          noBorder && _CLASSES.NO_BORDER,
          fullheight && _CLASSES.FULLHEIGHT,
          isPlaceholder && _CLASSES.PLACEHOLDER,
          overflow && _CLASSES.OVERFLOW,
          className
        );
      }, [
        theme,
        square,
        dense,
        narrow,
        flat,
        isPlaceholder,
        raised,
        noBorder,
        fullheight,
        overflow,
        className,
      ]);

      const getInlineStyle = useMemo(() => {
        let result = {};

        if (AcIsSet(width)) {
          if (width.toString().indexOf('rem') > -1) result.width = width;
          else result.width = `${width / 10}rem`;
        }

        if (AcIsSet(height)) {
          if (height.toString().indexOf('rem') > -1) result.height = height;
          else result.height = `${height / 10}rem`;
        }

        return result;
      }, [width, height]);

      return (
        <article id={id} className={getStyleClassNames} style={getInlineStyle} ref={ref} {...rest}>
          {children}
        </article>
      );
    }
  )
);

AcCard.displayName = 'AcCard';
AcCard.propTypes = Props;

export {AcCard};
export default AcCard;
